import React, { FunctionComponent, SyntheticEvent, useEffect, useState } from "react";
import styles from "./AppVersion.module.css";
import {
    Autocomplete,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import {
  CustomTextField,
  InputPropsForAddAffiliates,
} from "../../helper";
import { set, useForm } from "react-hook-form";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_AVAILABLE_ALTERNATE_NAMES, INSERT_ALTERNATE_NAME, SEARCH_LEAGUE, SEARCH_LEAGUE_CATEGORIES } from "./api/TnCs&PPQuery";
import ToasterWithMessage from "../../components/shared-components/toaster";
import images from "../../assets/images";

const InputField = CustomTextField();

const defaultValues = {
  aliasName: '',
  brandName: '',
  marketName: ''
};

interface FormdataProps {
    aliasName: string,
    brandName: string,
    marketName: string
}

interface league{
    l_id:string,
    l_name:string
}
interface leagueCategory{
    lc_id:string,
    lc_name:string,
    lc_alternate_name:string
}
interface availableAlternateName {
  lc_alternate_name:string[]
}
const TeamUpdate: FunctionComponent = () => {
  const [disableBtn, setDisableBtn] = useState<boolean>(true);
  const [searchText, setSearchText] = useState<league|null>(null);
  const [searchLeagueCategoryText, setSearchLeagueCategoryText] = useState<leagueCategory|null>(null);
  const [leagueList, setLeagueList] = useState<league[]>();
  const [leagueCategoryList, setLeagueCategoryList] = useState<leagueCategory[]>();
  const [availableAltNames, setAvailableAltNames] = useState<string[]|null>();
  const [aliasName, setAliasName] = useState<string|null>("");
  const [existingBrandName, setExistingBrandName] = useState<string|null>("");
  const [brandName, setBrandName] = useState<string|null>("");
  const [existingMarketName, setExistingMarketName] = useState<string|null>("");
  const [marketName, setMarketName] = useState<string|null>("");
  const [editMarket, setEditMarket] = useState<boolean>(false);
  const [editBrand, setEditBrand] = useState<boolean>(false);
  const {UserEdit} = images;

  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    getValues,
    watch,
    reset,
    trigger,
    setError,
    clearErrors
  } = useForm<FormdataProps>({
    defaultValues: defaultValues,
    mode: "onTouched",
  });

  const { error, success } = ToasterWithMessage();
  const getAutocompleteStyles = () => ({
    '& .MuiInputLabel-root': {
      display: 'none',
    },
    '& .MuiOutlinedInput-root': {
        fontFamily:"Glegoo",
        borderRadius: 0,
        fontSize: "13px",
    },
    '& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--neutral-600)', 
      },
    '& .MuiOutlinedInput-input': {
      padding: '10px',
    },
    "& .MuiInputBase-root.Mui-disabled": {
      "& > fieldset": {
        borderColor: 'var(--neutral-600)', 
      }
  }
  });
  const [searchLeague, { loading }] = useLazyQuery(
    SEARCH_LEAGUE,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data && data.leagues) {
          const leaguesToExtract = ['WWE', 'Theatres', 'Concert'];
          const filteredLeagues = data.leagues.filter((league:league) => !leaguesToExtract.includes(league.l_name));
          setLeagueList(filteredLeagues);
        }
      },
    }
  );
  const [searchLeagueCategories, { loading:catergoryLoading }] = useLazyQuery(
    SEARCH_LEAGUE_CATEGORIES,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data) {
          setLeagueCategoryList(data.league_categories)
        }
      },
    }
  );

  const [getAvailableAlternateName, { loading:alternateLoading }] = useLazyQuery(
    GET_AVAILABLE_ALTERNATE_NAMES,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data) {
          setAvailableAltNames(data.league_categories?.[0]?.lc_alternate_name ?? null);
          setExistingBrandName(data.league_categories?.[0]?.lc_brand_name ?? null);
          setExistingMarketName(data.league_categories?.[0]?.lc_market_name ?? null);
          setEditBrand(false);
          setEditMarket(false);
        }
      },
    }
  );

  const [addAliasName, { loading: updateLoading }] = useMutation(
    INSERT_ALTERNATE_NAME,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data) {
          success(data?.insertAlternateName?.message);
          handleReset();
        }
      },
      onError: (err) => {
        (err?.message?.includes("current team")||err?.message?.includes("already exists for team"))?error(err?.message):error("Something went Wrong!");
      },
    }
  );

useEffect(()=>{
    searchLeague({
        variables:{}
    })
},[]);

useEffect(()=>{
  if(searchText!==null && searchLeagueCategoryText!==null){
  getAvailableAlternateName({
    variables:{
      l_id:searchText?.l_id,
      lc_id:searchLeagueCategoryText?.lc_id
    }
  })
}
},[searchText,searchLeagueCategoryText]);

  const handleSearch = (event: any, value: league|null) => {
    if(value){
        const inputValue = value
        searchLeagueCategories({
            variables:{
                leagueId:inputValue.l_id
            }
        })
        setSearchText(inputValue);
    }
  }
  const handleSearchCategory = (event: any, value: leagueCategory|null) => {
    if(value){
        const inputValue = value
        setSearchLeagueCategoryText(inputValue);
    }
  }
  
  const handleEditIcon = (fieldName: string) => {
    setDisableBtn(true);
    if(fieldName === "brandName") {
      setEditBrand(!editBrand);
      setValue("brandName", existingBrandName || "");
      setBrandName(existingBrandName || "");
    }
    if(fieldName === "marketName") {
      setEditMarket(!editMarket);
      setValue("marketName", existingMarketName || "");
      setMarketName(existingMarketName || "");
    }
  }

  const handleChangeName = (e: React.ChangeEvent<HTMLInputElement>, fieldName: 'aliasName' | 'brandName' | 'marketName') => {
    clearErrors(fieldName);
    const input = e.target.value;
    const regexPattern = /^(?!.* {2})[a-zA-Z0-9\s!"$%&'()*+,-./:;=?@[\]^_`{|}~]*$/;
    if(input.length > 0){
                  if (regexPattern.test(input)) {
                      switch(fieldName) {
                        case 'aliasName':
                          setValue('aliasName', input);
                          setAliasName(input);
                          trigger('aliasName');
                          break;
                        case 'brandName':
                          setValue('brandName', input);
                          setBrandName(input);
                          trigger('brandName');
                          break;
                        case 'marketName':
                          setValue('marketName', input);
                          setMarketName(input);
                          trigger('marketName');
                          break;
                      }
                  } else {
                    switch(fieldName) {
                        case 'aliasName':
                          setAliasName(aliasName);
                          break;
                        case 'brandName':
                          setBrandName(brandName);
                          break;
                        case 'marketName':
                          setMarketName(marketName);
                          break;
                    }
                    setDisableBtn(true);
                  }
  }else {  
      switch(fieldName) {
          case 'aliasName':
                  trigger('aliasName');
                  setAliasName('');
                  break;
          case 'brandName':
                  trigger('brandName');
                  setBrandName('');
                  break;
          case 'marketName':
                  trigger('marketName');
                  setMarketName('');
                  break;
      }
      setDisableBtn(true);
  }
  };

  useEffect(()=>{
      if ((searchText && searchLeagueCategoryText) !== null) {
        const hasAlias = aliasName !== null && aliasName.trim() !== "";
        const hasBrand = brandName !== null && brandName.trim() !== "" && brandName !== existingBrandName;
        const hasMarket = marketName !== null && marketName.trim() !== "" && marketName !== existingMarketName;

        if (hasAlias || hasBrand || hasMarket) {
          setDisableBtn(false);
        } else {
          setDisableBtn(true);
        }
      } else {
        setDisableBtn(true);
      }
  },[aliasName,searchText,searchLeagueCategoryText, brandName, marketName]);

  const onSubmitAliasName = (data: FormdataProps) => {
    console.log("data --- ",data);

      addAliasName({
        variables: {
          leagueCategoryId: searchLeagueCategoryText?.lc_id,
          ...(data?.aliasName?.trim() !== '' && {alternateName: data?.aliasName?.trim()}),
          ...(data?.brandName?.trim() !== '' && {brandName: data?.brandName?.trim()}),
          ...(data?.marketName?.trim() !== '' && {marketName: data?.marketName?.trim()})
        },
      });
  };

  const handleReset = () => {
    setAliasName(null);
    setValue("aliasName", "");
    setLeagueCategoryList([]);
    setSearchLeagueCategoryText(null);
    setSearchText(null);
    setAvailableAltNames(null);
    setBrandName(null);
    setValue("brandName", "");
    setExistingBrandName(null);
    setEditBrand(false);
    setEditMarket(false);
    setMarketName(null);
    setValue("marketName", "");
    setExistingMarketName(null);
    reset();
  };

 const handleInput=()=>{
    setLeagueCategoryList([]);
    setSearchLeagueCategoryText(null);
    setAvailableAltNames(null);
    setSearchText(null);
    setValue('aliasName',"");
    setAliasName(null);
    clearErrors('aliasName')
    setValue('brandName',"");
    setBrandName(null);
    clearErrors('brandName')
 }
 const handleLeagueCategoryInput=()=>{
  setSearchLeagueCategoryText(null);
  setAvailableAltNames(null);
  setValue('aliasName',"");
  setAliasName(null);
  clearErrors('aliasName');
  setValue('brandName',"");
  setBrandName(null);
  clearErrors('brandName');
  setValue('marketName',"");
  setMarketName(null);
  clearErrors('marketName');
}

  return (
    <>
      {updateLoading ? (
        <div className={styles.circularProgressappVersion}>
          <CircularProgress color="primary" size={35} />
        </div>
      ) : (
        <form onSubmit={handleSubmit(onSubmitAliasName)}>
          <div className={styles.maindiv}>
            <div className={styles.seconddiv}>
            <div className={styles.firstTwoFieldsStyle}>
              <div className={styles.textFieldFullMainappversion + " " + styles.firstTwo}>
                <div className={styles.titlePlaceholderappversion}>
                  <b className={styles.AppOs}>League</b>
                </div>
                <div className={styles.autocompleteDiv}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    sx={getAutocompleteStyles}
                    options={leagueList ?? []}
                    loading={loading}
                    value={searchText}
                    onChange={handleSearch}
                    onInputChange={handleInput}
                    autoHighlight
                    getOptionLabel={(option:league) => option.l_name || "-"}
                    isOptionEqualToValue={(option:league, value:league) => option.l_id === value.l_id}
                    getOptionKey={(option:league)=>option.l_id}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select League"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </div>
              </div>
              <div className={styles.textFieldFullMainappversion + " " + styles.firstTwo}>
                <div className={styles.titlePlaceholderappversion}>
                  <b className={styles.AppOs}>Team Name</b>
                </div>
                <div className={styles.autocompleteDiv}>
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    sx={getAutocompleteStyles}
                    options={leagueCategoryList ?? []}
                    value={searchLeagueCategoryText}
                    loading={catergoryLoading}
                    disabled={searchText?false:true}
                    onChange={handleSearchCategory}
                    onInputChange={handleLeagueCategoryInput}
                    autoHighlight
                    clearOnBlur={true}
                    getOptionLabel={(option:leagueCategory) => option.lc_name || "-"}
                    isOptionEqualToValue={(option:leagueCategory, value:leagueCategory) => option.lc_id === value.lc_id}
                    getOptionKey={(option:leagueCategory)=>option.lc_id}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Team Name"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
              <div className={styles.textFieldFullMainappversion}>
                <div className={styles.titlePlaceholderappversion}>
                  <b className={styles.AppOs}>Existing Alternate Names</b>
                </div>
                  <div className={styles.availableAltNames}>
                    {alternateLoading ? (
                      <div className={styles.altNamesList}>
                        <div className={styles.hyphen}>-</div>
                      </div>
                    ) : (
                      <div className={styles.altNamesList}>
                        {availableAltNames && availableAltNames.length > 0 ? (
                          <div className={styles.altNamesContainer}>
                            {availableAltNames.length > 10 ? (
                              <>
                                <div className={styles.leftColumn}>
                                  {availableAltNames.slice(0, Math.ceil(availableAltNames.length / 2)).map((altName, index) => (
                                    <div className={styles.altname} key={index}>{altName}</div>
                                  ))}
                                </div>
                                <div className={styles.rightColumn}>
                                  {availableAltNames.slice(Math.ceil(availableAltNames.length / 2)).map((altName, index) => (
                                    <div className={styles.altname} key={index + Math.ceil(availableAltNames.length / 2)}>{altName}</div>
                                  ))}
                                </div>
                              </>
                            ) : (
                              <div>
                                {availableAltNames?.map((altName, index) => (
                                  <div className={styles.altname} key={index}>{altName}</div>
                                ))}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className={styles.hyphen}>-</div>
                        )}
                      </div>
                    )}
                  </div>
              </div>
              <div className={styles.textFieldFullMainAliasName}>
                <div className={styles.titlePlaceholderappversion}>
                  <b className={styles.AppOs}>Alternate Name</b>
                </div>
                <InputField
                  variant="outlined"
                  disabled={searchLeagueCategoryText?false:true}
                  fullWidth
                  {...register("aliasName")}
                  value={aliasName}
                  placeholder={"Enter Alternate Name"}
                  InputProps={{
                    style: InputPropsForAddAffiliates,
                  }}
                  error={Boolean(errors?.aliasName?.message)}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChangeName(e, "aliasName")
                  }
                />
                <span className={styles.errorMsgStyle}>
                  {errors?.aliasName?.message}
                </span>
              </div>
              <div className={styles.textFieldFullMainappversion + " " + styles.brandTextField}>
                <div className={styles.titlePlaceholderappversion + " " + styles.brandNameDiv}>
                  <b className={styles.AppOs}>{existingBrandName ? 'Existing Brand Name' : 'Brand Name'}</b>
                  {existingBrandName && 
                    <Button 
                      classes={{root: styles.editSeparateStyle}} 
                      fullWidth 
                      onClick={() => handleEditIcon("brandName")}>
                      <img src={UserEdit} alt="useredit" />
                    </Button>
                  }
                </div>
                  <div className={styles.availableBrandNames}>
                    {alternateLoading ? (
                      <div className={styles.altNamesList}>
                        <div className={styles.hyphen}>-</div>
                      </div>
                    ) : (
                        (!editBrand && existingBrandName) ? (
                        <div className={styles.altNamesList}>
                            <div className={styles.altNamesContainer}>
                                <div>
                                    <div className={styles.altname}>{existingBrandName}</div>
                                </div>
                            </div>
                        </div>
                        ) : (
                          <InputField
                            variant="outlined"
                            disabled={searchLeagueCategoryText?false:true}
                            fullWidth
                            {...register("brandName")}
                            value={brandName}
                            placeholder={"Enter Brand Name"}
                            InputProps={{
                              style: InputPropsForAddAffiliates,
                            }}
                            error={Boolean(errors?.brandName?.message)}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                              handleChangeName(e, "brandName")
                            }
                          />
                        )
                    )}
                  </div>
              </div>


              <div className={styles.textFieldFullMainappversion + " " + styles.marketTextField}>
                <div className={styles.titlePlaceholderappversion + " " + styles.brandNameDiv}>
                  <b className={styles.AppOs}>{existingMarketName ? 'Existing Market Name' : 'Market Name'}</b>
                  {existingMarketName && 
                    <Button 
                      classes={{root: styles.editSeparateStyle}} 
                      fullWidth 
                      onClick={() => handleEditIcon("marketName")}>
                      <img src={UserEdit} alt="useredit" />
                    </Button>
                  }
                </div>
                  <div className={styles.availableBrandNames}>
                    {alternateLoading ? (
                      <div className={styles.altNamesList}>
                        <div className={styles.hyphen}>-</div>
                      </div>
                    ) : (
                        (!editMarket && existingMarketName) ? (
                        <div className={styles.altNamesList}>
                            <div className={styles.altNamesContainer}>
                                <div>
                                    <div className={styles.altname}>{existingMarketName}</div>
                                </div>
                            </div>
                        </div>
                        ) : (
                          <InputField
                            variant="outlined"
                            disabled={searchLeagueCategoryText?false:true}
                            fullWidth
                            {...register("marketName")}
                            value={marketName}
                            placeholder={"Enter Market Name"}
                            InputProps={{
                              style: InputPropsForAddAffiliates,
                            }}
                            error={Boolean(errors?.marketName?.message)}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                              handleChangeName(e, "marketName")
                            }
                          />
                        )
                    )}
                  </div>
              </div>
            </div>

            <div className={styles.updateTeamBtnContainer}>
              <div className={styles.resetbuttonStyle} onClick={handleReset}>
                <Button
                  classes={{ root: styles.separateStyleforcancelReferral }}
                  fullWidth
                  disableRipple
                >
                  Reset
                </Button>
              </div>
              <div
                className={
                  disableBtn ? styles.disabledButton : styles.updateTeamButtonStyle
                }
              >
                <Button
                  classes={{
                    root: disableBtn
                      ? styles.separateStyledisabledUpdateBtn
                      : styles.separateStyleReferral,
                  }}
                  disableRipple
                  fullWidth
                  type="submit"
                  disabled={disableBtn}
                >
                  Update
                </Button>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default TeamUpdate;
